/*
 * GENERATED from fabulous-studio-orderflow/api/_lib/caption-core.js by scripts/sync-caption-core.mjs, do not edit.
 *
 * Naam-ondertitel over de AI-preview, identiek aan wat de server in de print brandt.
 * API: window.FPCaption.ready(opentypeUrl, fontUrl) -> Promise; daarna check(raw), svg(text, W, H), layout(text, W, H).
 * Vereist assets: opentype.min.js (opentype.js 2.0.0, MIT, https://github.com/opentypejs/opentype.js)
 * en fp-caption-font.js (window.FPCaptionFontB64: subset van Cormorant Garamond SemiBold Italic).
 *
 * Font-licentie (fp-caption-font.js), https://openfontlicense.org:
 *
 * Copyright 2015 the Cormorant Project Authors (github.com/CatharsisFonts/Cormorant)
 *
 * This Font Software is licensed under the SIL Open Font License, Version 1.1.
 * This license is copied below, and is also available with a FAQ at:
 * https://scripts.sil.org/OFL
 *
 *
 * -----------------------------------------------------------
 * SIL OPEN FONT LICENSE Version 1.1 - 26 February 2007
 * -----------------------------------------------------------
 *
 * PREAMBLE
 * The goals of the Open Font License (OFL) are to stimulate worldwide
 * development of collaborative font projects, to support the font creation
 * efforts of academic and linguistic communities, and to provide a free and
 * open framework in which fonts may be shared and improved in partnership
 * with others.
 *
 * The OFL allows the licensed fonts to be used, studied, modified and
 * redistributed freely as long as they are not sold by themselves. The
 * fonts, including any derivative works, can be bundled, embedded, 
 * redistributed and/or sold with any software provided that any reserved
 * names are not used by derivative works. The fonts and derivatives,
 * however, cannot be released under any other type of license. The
 * requirement for fonts to remain under this license does not apply
 * to any document created using the fonts or their derivatives.
 *
 * DEFINITIONS
 * "Font Software" refers to the set of files released by the Copyright
 * Holder(s) under this license and clearly marked as such. This may
 * include source files, build scripts and documentation.
 *
 * "Reserved Font Name" refers to any names specified as such after the
 * copyright statement(s).
 *
 * "Original Version" refers to the collection of Font Software components as
 * distributed by the Copyright Holder(s).
 *
 * "Modified Version" refers to any derivative made by adding to, deleting,
 * or substituting -- in part or in whole -- any of the components of the
 * Original Version, by changing formats or by porting the Font Software to a
 * new environment.
 *
 * "Author" refers to any designer, engineer, programmer, technical
 * writer or other person who contributed to the Font Software.
 *
 * PERMISSION & CONDITIONS
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of the Font Software, to use, study, copy, merge, embed, modify,
 * redistribute, and sell modified and unmodified copies of the Font
 * Software, subject to the following conditions:
 *
 * 1) Neither the Font Software nor any of its individual components,
 * in Original or Modified Versions, may be sold by itself.
 *
 * 2) Original or Modified Versions of the Font Software may be bundled,
 * redistributed and/or sold with any software, provided that each copy
 * contains the above copyright notice and this license. These can be
 * included either as stand-alone text files, human-readable headers or
 * in the appropriate machine-readable metadata fields within text or
 * binary files as long as those fields can be easily viewed by the user.
 *
 * 3) No Modified Version of the Font Software may use the Reserved Font
 * Name(s) unless explicit written permission is granted by the corresponding
 * Copyright Holder. This restriction only applies to the primary font name as
 * presented to the users.
 *
 * 4) The name(s) of the Copyright Holder(s) or the Author(s) of the Font
 * Software shall not be used to promote, endorse or advertise any
 * Modified Version, except to acknowledge the contribution(s) of the
 * Copyright Holder(s) and the Author(s) or with their explicit written
 * permission.
 *
 * 5) The Font Software, modified or unmodified, in part or in whole,
 * must be distributed entirely under this license, and must not be
 * distributed under any other license. The requirement for fonts to
 * remain under this license does not apply to any document created
 * using the Font Software.
 *
 * TERMINATION
 * This license becomes null and void if any of the above conditions are
 * not met.
 *
 * DISCLAIMER
 * THE FONT SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT
 * OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO EVENT SHALL THE
 * COPYRIGHT HOLDER BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL
 * DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF THE USE OR INABILITY TO USE THE FONT SOFTWARE OR FROM
 * OTHER DEALINGS IN THE FONT SOFTWARE.
 */
(function () {
"use strict";
if (window.FPCaption) return;

// ===== begin caption-core.js =====
/**
 * caption-core.js: naam/titel als sierlijke ondertitel op een portret.
 *
 * ENIGE BRON van de opmaak. Dezelfde code draait:
 *   - op de server (api/_lib/caption.ts, sharp/librsvg brandt de SVG in de 4K-master
 *     en de digitale download), en
 *   - in de browser (theme/assets/fp-caption.js, gegenereerd door
 *     scripts/sync-caption-core.mjs; de SVG ligt live over de preview).
 * Tekst wordt met opentype.js omgezet naar vectorpaden, dus nergens systeemfonts en
 * dezelfde invoer geeft byte-voor-byte dezelfde SVG.
 *
 * Regels voor dit bestand: puur modern JS, geen imports, geen DOM, geen Node-API's.
 * Alleen top-level `export` gebruiken op declaraties (de sync-generator haalt het
 * woord `export` weg en zet alles in een IIFE). Na elke wijziging:
 *   node scripts/sync-caption-core.mjs
 *
 * Alle maten zijn relatief aan beeldbreedte W en -hoogte H (2:3-portret).
 */

// ---------------------------------------------------------------------------
// Opmaak-specificatie
// ---------------------------------------------------------------------------

const MAX_CHARS = 32;

const FONT_SIZE = 0.09; // em-grootte x W
const MIN_FONT_SIZE = 0.045; // x W, ondergrens bij krimpen
const MAX_TEXT_WIDTH = 0.76; // x W, maximale advance-breedte (met kerning)
const TEXT_X = 0.5; // x W, horizontaal midden
const TEXT_BASELINE = 0.85; // x H, alfabetische basislijn

const SCRIM_TOP = 0.64; // x H, scrim loopt tot onderkant
const SCRIM_RGB = "rgb(28,16,6)";
const SCRIM_ALPHA = 0.58;

const GOLD_STOPS = [
  [0, "#fbeec8"],
  [0.45, "#e8c57e"],
  [0.6, "#c99a4b"],
  [1, "#f1d69a"],
];

const SHADOW_RGB = "rgb(35,18,4)";
const SHADOW_A = { dy: 0.002, sd: 0.001, alpha: 0.65 }; // x W
const SHADOW_B = { dy: 0, sd: 0.0068, alpha: 0.35 }; // x W
const FILTER_PAD = 0.05; // x W, marge boven/onder de em-box voor de blur

const ORN_Y = 0.874; // x H, verticaal midden van het ornament (vast)
const ORN_LINE = 0.068; // x W, lengte per lijn
const ORN_THICK = 0.0015; // x W, lijndikte
const ORN_DIAMOND = 0.0068; // x W, zijde van het vierkant (45 graden gedraaid)
const ORN_GAP = 0.0098; // x W, ruimte tussen ruit-box en lijn
const ORN_COLOR = "#e2c07e";
const ORN_LINE_OPACITY = 0.85;
const ORN_DIAMOND_OPACITY = 0.9;

const RENDER_OPTIONS = { kerning: true };

// ---------------------------------------------------------------------------
// Blocklist: hele woorden, hoofdletter-ongevoelig, na wegvouwen van accenten.
// Een * aan het eind = voorvoegsel (alleen voor stammen die geen naam kunnen zijn).
// Bewust NIET opgenomen omdat het echte (sur)namen of gewone woorden zijn:
// dick, cock, coon, dyke, hell, heil, fick, pik, nicht, willy, fanny, schwanz, negro.
// ---------------------------------------------------------------------------

const BLOCKLIST = [
  // Engels
  "fuck*", "motherfuck*", "fck", "fuk", "fcking", "stfu", "wtf",
  "shit", "shits", "shitty", "shithead", "bullshit",
  "bitch", "bitches", "bastard", "bastards", "cunt", "cunts", "twat", "wanker",
  "prick", "dickhead", "asshole", "arsehole", "ass", "arse",
  "pussy", "whore", "slut", "sluts", "jizz", "porn", "penis", "vagina", "tits",
  "nigger*", "nigga*", "faggot*", "fag", "fags", "kike", "spic", "chink", "gook",
  "wetback", "raghead", "towelhead", "paki", "tranny", "retard", "retarded",
  "nazi", "nazis", "hitler", "kkk", "rape", "rapist", "pedo",
  // Nederlands
  "kut", "lul", "neuk", "neuken", "neuker", "hoer", "hoeren", "hoerenzo*",
  "slet", "sletten", "klootzak", "klootzakken", "kanker*", "tering*", "tyfus*",
  "klerelijer", "godverdomme", "mongool", "flikker", "flikkers",
  "neger", "negers", "kaffer", "eikel", "trut",
  // Duits
  "arsch", "arschloch*", "scheisse", "scheiss", "ficken", "ficker", "fickt",
  "fotze*", "hure", "hurensohn*", "wichser", "schlampe", "schwuchtel*",
  "kanake", "kanaken", "spast", "spasti", "missgeburt", "mongo", "titten",
  "pimmel", "muschi", "kacke", "nutte", "bumsen",
];

const BLOCK_EXACT = new Set();
const BLOCK_PREFIX = [];
for (const entry of BLOCKLIST) {
  if (entry.endsWith("*")) BLOCK_PREFIX.push(entry.slice(0, -1));
  else BLOCK_EXACT.add(entry);
}

function foldForBlocklist(s) {
  return s
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/æ/g, "ae")
    .replace(/œ/g, "oe")
    .replace(/ø/g, "o")
    .replace(/ł/g, "l")
    .replace(/đ/g, "d");
}

function isBlockedWord(word) {
  if (!word) return false;
  if (BLOCK_EXACT.has(word)) return true;
  for (const p of BLOCK_PREFIX) if (word.startsWith(p)) return true;
  return false;
}

function isBlocked(text) {
  const folded = foldForBlocklist(text);
  const words = folded.split(/[^a-z0-9]+/);
  for (const w of words) if (isBlockedWord(w)) return true;
  // Ook de hele tekst zonder spaties/leestekens ("f u c k", "K.U.T"), alleen exact:
  // een voorvoegsel-match op aaneengeplakte woorden geeft valse treffers bij namen.
  const joined = folded.replace(/[^a-z0-9]+/g, "");
  return joined !== "" && (BLOCK_EXACT.has(joined) || BLOCK_PREFIX.indexOf(joined) >= 0);
}

// ---------------------------------------------------------------------------
// Hulpfuncties
// ---------------------------------------------------------------------------

// "!" sinds 23 okt 2026 ("Merry Christmas!" werd geweigerd; zit in de font-subset U+0020-007E).
const ALLOWED_CHAR = /^[\p{L}0-9 &’\-.,!]$/u;
const HAS_LETTER_OR_DIGIT = /[\p{L}0-9]/u;

/** Rond af op 2 decimalen en geef de kortste string (deterministisch). */
function num(v) {
  const r = Math.round(v * 100) / 100;
  return String(r === 0 ? 0 : r);
}

/** Korte, deterministische hash (FNV-1a 32 bit) voor unieke id's per tekst. */
function hash36(s) {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(36);
}

/**
 * Padcommando's van opentype.js als SVG-padtekst. Bewust niet via toPathData():
 * opentype.js 2.0.0 schrijft een coordinaat als 1696.0000000000002 uit als "NaN", en een
 * tekenaar (librsvg, browsers) stopt bij het eerste ongeldige getal, zodat de rest van de
 * naam stil wegvalt (FP19679: familienaam halverwege afgekapt). Liever een
 * fout dan een halve naam: alles wat geen commando of getal is, wordt geweigerd.
 */
function pathData(commands) {
  let d = "";
  for (const c of commands) {
    if (c.type === "M" || c.type === "L") d += c.type + num(c.x) + " " + num(c.y);
    else if (c.type === "Q") d += "Q" + num(c.x1) + " " + num(c.y1) + " " + num(c.x) + " " + num(c.y);
    else if (c.type === "C") {
      d += "C" + num(c.x1) + " " + num(c.y1) + " " + num(c.x2) + " " + num(c.y2) + " " + num(c.x) + " " + num(c.y);
    } else if (c.type === "Z") d += "Z";
    else throw new Error("caption.svg: onbekend padcommando " + c.type);
  }
  if (!/^[MLQCZ0-9 .-]+$/.test(d)) throw new Error("caption.svg: ongeldig getal in het letterpad");
  return d;
}

function escapeAttr(s) {
  return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}

// ---------------------------------------------------------------------------
// Publieke API
// ---------------------------------------------------------------------------

/**
 * @param {object} font Een geparste opentype.js Font (Cormorant Garamond SemiBold Italic subset).
 */
function createCaption(font) {
  if (!font || typeof font.getPath !== "function" || typeof font.getAdvanceWidth !== "function") {
    throw new Error("createCaption: geen geldige opentype.js Font");
  }
  const upm = font.unitsPerEm || 1000;

  /** Advance-breedte in em (met kerning), lineair in de fontgrootte. */
  function advanceEm(text) {
    return font.getAdvanceWidth(text, 1, RENDER_OPTIONS);
  }

  function check(raw) {
    if (raw === null || raw === undefined) return { ok: false, value: null, reason: "empty" };
    const s = String(raw)
      .normalize("NFC")
      .replace(/['‘ʼ`´]/g, "’")
      .replace(/\s+/gu, " ")
      .trim();
    if (!s) return { ok: false, value: null, reason: "empty" };

    const chars = Array.from(s);
    if (chars.length > MAX_CHARS) return { ok: false, value: null, reason: "too_long" };

    for (const ch of chars) {
      if (!ALLOWED_CHAR.test(ch)) return { ok: false, value: null, reason: "chars" };
      if (!(font.charToGlyphIndex(ch) > 0)) return { ok: false, value: null, reason: "chars" };
    }
    if (!HAS_LETTER_OR_DIGIT.test(s)) return { ok: false, value: null, reason: "chars" };

    // Moet op minimale fontgrootte binnen de maximale breedte passen.
    if (advanceEm(s) * MIN_FONT_SIZE > MAX_TEXT_WIDTH) {
      return { ok: false, value: null, reason: "too_long" };
    }

    if (isBlocked(s)) return { ok: false, value: null, reason: "blocked" };

    return { ok: true, value: s };
  }

  function layout(text, W, H) {
    const maxWidth = MAX_TEXT_WIDTH * W;
    let fontSize = FONT_SIZE * W;
    let advance = advanceEm(text) * fontSize;
    if (advance > maxWidth) {
      fontSize = fontSize * (maxWidth / advance);
      advance = advanceEm(text) * fontSize;
    }
    if (fontSize < MIN_FONT_SIZE * W) {
      fontSize = MIN_FONT_SIZE * W;
      advance = advanceEm(text) * fontSize;
    }
    return { fontSize, advance, x: TEXT_X * W - advance / 2, baseline: TEXT_BASELINE * H };
  }

  /**
   * Bouwt de SVG. `top` > 0 geeft alleen de strook [top, H] (zelfde tekening, zelfde
   * coordinaten, alleen de viewBox verschoven); de server gebruikt dat om geheugen te
   * sparen, want librsvg maakt filteroppervlakken ter grootte van het hele canvas.
   */
  function build(text, W, H, top) {
    if (typeof text !== "string" || !text) throw new Error("caption.svg: lege tekst");
    if (!(W > 0) || !(H > 0)) throw new Error("caption.svg: ongeldige afmetingen");

    const L = layout(text, W, H);
    const id = "fpc" + num(W).replace(".", "_") + "x" + num(H).replace(".", "_") + "-" + hash36(text);

    // Tekst als vectorpad.
    const d = pathData(font.getPath(text, L.x, L.baseline, L.fontSize, RENDER_OPTIONS).commands);

    // Goudverloop over de em-box (basislijn - ascender tot basislijn - descender).
    const emTop = L.baseline - (font.ascender / upm) * L.fontSize;
    const emBottom = L.baseline - (font.descender / upm) * L.fontSize;
    const goldStops = GOLD_STOPS.map(
      ([o, c]) => '<stop offset="' + num(o) + '" stop-color="' + c + '"/>'
    ).join("");

    // Filtergebied: volle breedte, em-box plus ruime marge voor de blur.
    const pad = FILTER_PAD * W;
    const fy = emTop - pad;
    const fh = emBottom - emTop + 2 * pad;

    // Scrim.
    const scrimY = SCRIM_TOP * H;

    // Ornament: lijn, ruit, lijn; ruit-box (ongedraaid) + gap bepaalt de lijnafstand.
    const cx = 0.5 * W;
    const cy = ORN_Y * H;
    const half = (ORN_DIAMOND * W) / 2;
    const inner = half + ORN_GAP * W;
    const outer = inner + ORN_LINE * W;
    const t = ORN_THICK * W;
    const r = (ORN_DIAMOND * W * Math.SQRT2) / 2; // halve diagonaal van de gedraaide ruit
    const lineY = cy - t / 2;
    const lines =
      '<rect x="' + num(cx - outer) + '" y="' + num(lineY) + '" width="' + num(ORN_LINE * W) +
      '" height="' + num(t) + '"/>' +
      '<rect x="' + num(cx + inner) + '" y="' + num(lineY) + '" width="' + num(ORN_LINE * W) +
      '" height="' + num(t) + '"/>';
    const diamond =
      "M" + num(cx) + " " + num(cy - r) + "L" + num(cx + r) + " " + num(cy) +
      "L" + num(cx) + " " + num(cy + r) + "L" + num(cx - r) + " " + num(cy) + "Z";

    return (
      '<svg xmlns="http://www.w3.org/2000/svg" width="' + num(W) + '" height="' + num(H - top) +
      '" viewBox="0 ' + num(top) + " " + num(W) + " " + num(H - top) + '">' +
      "<defs>" +
      '<linearGradient id="' + id + '-scrim" gradientUnits="userSpaceOnUse" x1="0" y1="' + num(scrimY) +
      '" x2="0" y2="' + num(H) + '">' +
      '<stop offset="0" stop-color="' + SCRIM_RGB + '" stop-opacity="0"/>' +
      '<stop offset="1" stop-color="' + SCRIM_RGB + '" stop-opacity="' + num(SCRIM_ALPHA) + '"/>' +
      "</linearGradient>" +
      '<linearGradient id="' + id + '-gold" gradientUnits="userSpaceOnUse" x1="0" y1="' + num(emTop) +
      '" x2="0" y2="' + num(emBottom) + '">' + goldStops + "</linearGradient>" +
      '<filter id="' + id + '-shadow" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse"' +
      ' color-interpolation-filters="sRGB" x="0" y="' + num(fy) + '" width="' + num(W) +
      '" height="' + num(fh) + '">' +
      // (a) korte, harde schaduw iets naar onder
      '<feGaussianBlur in="SourceAlpha" stdDeviation="' + num(SHADOW_A.sd * W) + '" result="a1"/>' +
      '<feOffset in="a1" dx="0" dy="' + num(SHADOW_A.dy * W) + '" result="a2"/>' +
      '<feFlood flood-color="' + SHADOW_RGB + '" flood-opacity="' + num(SHADOW_A.alpha) + '" result="a3"/>' +
      '<feComposite in="a3" in2="a2" operator="in" result="a4"/>' +
      '<feMerge result="r1"><feMergeNode in="a4"/><feMergeNode in="SourceGraphic"/></feMerge>' +
      // (b) zachte gloed rondom (zoals CSS drop-shadow-keten: over tekst + schaduw a)
      '<feGaussianBlur in="r1" stdDeviation="' + num(SHADOW_B.sd * W) + '" result="b1"/>' +
      '<feOffset in="b1" dx="0" dy="' + num(SHADOW_B.dy * W) + '" result="b2"/>' +
      '<feFlood flood-color="' + SHADOW_RGB + '" flood-opacity="' + num(SHADOW_B.alpha) + '" result="b3"/>' +
      '<feComposite in="b3" in2="b2" operator="in" result="b4"/>' +
      '<feMerge><feMergeNode in="b4"/><feMergeNode in="r1"/></feMerge>' +
      "</filter>" +
      "</defs>" +
      '<rect x="0" y="' + num(scrimY) + '" width="' + num(W) + '" height="' + num(H - scrimY) +
      '" fill="url(#' + id + '-scrim)"/>' +
      '<path d="' + escapeAttr(d) + '" fill="url(#' + id + '-gold)" filter="url(#' + id + '-shadow)"/>' +
      '<g fill="' + ORN_COLOR + '"><g fill-opacity="' + num(ORN_LINE_OPACITY) + '">' + lines + "</g>" +
      '<path d="' + diamond + '" fill-opacity="' + num(ORN_DIAMOND_OPACITY) + '"/></g>' +
      "</svg>"
    );
  }

  /** Volledige SVG van W x H (transparant), voor de browser-overlay. */
  function svg(text, W, H) {
    return build(text, W, H, 0);
  }

  /**
   * Alleen de onderste strook (vanaf de scrim, hele pixels) als SVG van W x (H - top),
   * om op y = top te composeren. Pixel-gelijk aan het onderste deel van svg().
   */
  function svgBand(text, W, H) {
    const top = Math.floor(SCRIM_TOP * H);
    return { top, svg: build(text, W, H, top) };
  }

  return { check, svg, svgBand, layout };
}
// ===== einde caption-core.js =====

  // --- browser-wrapper ------------------------------------------------------
  var api = null;
  var readyPromise = null;

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      if (window.opentype && typeof window.opentype.parse === "function") return resolve();
      var s = document.createElement("script");
      s.src = url;
      s.async = true;
      s.onload = function () {
        if (window.opentype && typeof window.opentype.parse === "function") resolve();
        else reject(new Error("FPCaption: opentype.js geladen maar window.opentype ontbreekt"));
      };
      s.onerror = function () { reject(new Error("FPCaption: kon opentype.js niet laden: " + url)); };
      document.head.appendChild(s);
    });
  }

  function b64ToBuffer(b64) {
    var bin = atob(b64);
    var out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out.buffer;
  }

  function loadFont(url) {
    if (url.split("?")[0].slice(-3) === ".js") {
      if (typeof window.FPCaptionFontB64 === "string") return Promise.resolve(b64ToBuffer(window.FPCaptionFontB64));
      return new Promise(function (resolve, reject) {
        var s = document.createElement("script");
        s.src = url;
        s.async = true;
        s.onload = function () {
          if (typeof window.FPCaptionFontB64 === "string") resolve(b64ToBuffer(window.FPCaptionFontB64));
          else reject(new Error("FPCaption: font-script geladen maar FPCaptionFontB64 ontbreekt: " + url));
        };
        s.onerror = function () { reject(new Error("FPCaption: kon font-script niet laden: " + url)); };
        document.head.appendChild(s);
      });
    }
    return fetch(url, { credentials: "omit" }).then(function (r) {
      if (!r.ok) throw new Error("FPCaption: font laden mislukt (" + r.status + "): " + url);
      return r.arrayBuffer();
    });
  }

  function need() {
    if (!api) throw new Error("FPCaption: nog niet klaar, wacht eerst op FPCaption.ready(opentypeUrl, fontUrl)");
    return api;
  }

  window.FPCaption = {
    ready: function (opentypeUrl, fontUrl) {
      if (api) return Promise.resolve();
      if (!readyPromise) {
        // Font komt uit fp-caption-font.js (window.FPCaptionFontB64). Geen .ttf-asset:
        // Shopify's CDN levert die als woff2 en dat kan opentype.js niet lezen.
        readyPromise = loadScript(opentypeUrl)
          .then(function () { return loadFont(fontUrl); })
          .then(function (buf) {
            var sig = String.fromCharCode.apply(null, new Uint8Array(buf.slice(0, 4)));
            if (sig === "wOF2") throw new Error("FPCaption: font is woff2 (CDN-conversie?), opentype.js leest dat niet: " + fontUrl);
            api = createCaption(window.opentype.parse(buf));
          })
          .catch(function (err) { readyPromise = null; throw err; });
      }
      return readyPromise;
    },
    isReady: function () { return !!api; },
    check: function (raw) { return need().check(raw); },
    svg: function (text, W, H) { return need().svg(text, W, H); },
    layout: function (text, W, H) { return need().layout(text, W, H); },
  };
})();
